import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Employee } from '@models/company';
import { LawFirm } from '@models/lawFirms';
import { TestHooks } from './law-firms-create-side-form.hooks';

export interface CreateOrUpdateLawFirmModel {
	name: string;
	lawFirm: LawFirm;
}

@Component({
	selector: 'app-create-law-firm-side-form',
	templateUrl: './law-firms-create-side-form.component.html',
	standalone: false,
})
export class CreateLawFirmSideFormComponent {
	testHooks = TestHooks;
	@Input() name;
	public id;
	public lawFirm: LawFirm;

	@Output() onCreate = new EventEmitter();
	@Output() onCancel = new EventEmitter();

	constructor() {}

	onSubmit(event: Employee) {
		this.onCreate.emit(event);
	}

	_onCancel() {
		this.onCancel.emit();
	}
}
